import { render, staticRenderFns } from "./FulfillmentProductCatalog.vue?vue&type=template&id=789f80d0"
import script from "./FulfillmentProductCatalog.vue?vue&type=script&lang=js"
export * from "./FulfillmentProductCatalog.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentProductCatalog.vue?vue&type=style&index=0&id=789f80d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports